interface NameParts {
    firstname?: string | null
    lastname?: string | null
    affix?: string | null
}

// Accepts users with their name on the user itself (view models) or on their person (resources)
export interface UserWithName extends NameParts {
    person?: NameParts | null
}

export const getUserFullName = (user?: UserWithName | null): string => {
    if (! user) {
        return ''
    }

    const firstname = user.firstname || user.person?.firstname || ''
    const lastname = user.lastname || user.person?.lastname || ''
    const affix = user.affix || user.person?.affix || ''

    return `${firstname}${affix ? ` ${affix}` : ''} ${lastname}`
}
